export default function Subcategory(props){
 

    return(

        <div className="subcatpane">
            {

                props.category.length > 0 &&

                props.category.map((item,index) =>{
                    if(item.name.indexOf("HP") < 0){
                 return(
                     <a key={index+item.slug} className="btn btn-default subcatlinks"  href={(props.parent).toLowerCase()+"/"+item.slug}>&#43;&nbsp;{item.name}</a>
                 )
                    }

                })
            }
            
        </div>
    )
}